import React from 'react';

const RedNumberText = ({ before, number, after }) => {
  return (
    <span>
      {before && <span>{before}</span>}
      {typeof number === 'number' && (
        <span style={{ fontWeight: 'bold', color: 'red' }}>{number} </span>
      )}
      {after && <span>{after}</span>}
    </span>
  );
};

export default RedNumberText;
